import React from "react"
import { Center, Link, Image } from "@chakra-ui/react"
import poweredBy from "assets/images/powered-by-diobox.png"

type Props = {
  hideSeparator?: boolean
}

const PoweredBy = ({ hideSeparator }: Props) => (
  <Center borderTopWidth={hideSeparator ? 0 : 1} pt={8} pb={8}>
    <Link isExternal href="https://d.io/?ref=dioinvite">
      <Image
        src={poweredBy}
        w={110}
        h={35}
        alt="Diobox &copy; POWERED"
      />
    </Link>
  </Center>
)

export default PoweredBy
